import React from "react";
import "./StoryBubbleSkeleton.css";

export default function StoryBubbleSkeleton({ label = true }) {
  return (
    <div className="story-bubble-wrapper">
      <div className="story-bubble neutral">
        <div className="story-ring">
          <div className="story-inner">
            <div className="story-avatar-skel" />
          </div>
        </div>
      </div>

      {label && <div className="story-username-skel" />}
    </div>
  );
}
